import { Button, notification, Input, Form, Card, Modal } from "antd"
import Title from "antd/es/typography/Title"
import { GetToolHistoryByID, UpdateToolHistory } from "../../../api/AdminService"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons"
const AdminDetailToolHistory = () => {
    const [form] = Form.useForm()
    const { id } = useParams();
    const [ToolHistory, setToolHistory] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [numOfTool, setNumOfTool] = useState(0);
    console.log(ToolHistory)
    const navigate = useNavigate();
    const GetToolHistoryID = (id) => {
        console.log(id)
        GetToolHistoryByID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setToolHistory(res.data)
                form.setFieldsValue({
                    createAt: dayjs(res.data?.createAt).format("YYYY-MM-DD"),
                    numOfTool: res.data?.numOfTool,

                    name: res.data?.retreat?.name,
                    startDate: dayjs(res.data?.retreat?.startDate).format("YYYY-MM-DD"),
                    status: res.data?.retreat?.status,

                    toolName: res.data?.tool?.name,
                    toolStatus: res.data?.tool?.status,
                    toolTotal: res.data?.tool?.totalTool,

                    firstName: res.data?.borrower?.firstName,
                    lastName: res.data?.borrower?.lastName,
                    role: res.data?.borrower?.role,
                    email: res.data?.borrower?.email
                })
            }
        })
    }

    useEffect(() => {
        GetToolHistoryID(id);
    }, [])

    const showModal = () => {
        setNumOfTool(ToolHistory.numOfTool);
        setIsModalVisible(true);
    };

    const handleOk = () => {
        UpdateToolHistory(id, numOfTool).then(res => {
            if (res.status === 201) {
                notification.success({
                    message: "Update Tool History Successfully"
                });
                setIsModalVisible(false);
                GetToolHistoryID(id);
            }
        }).catch(err => {
            notification.error({
                message: `${err.response.data.message}`
            });
        });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <div style={{ minHeight: '96.5vh', Width: '100%' }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>
            <div style={{ maxWidth: 600, margin: 'auto', padding: '24' }}>

                <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
                    Tool History
                </Title>

                <Form
                    form={form}
                    name="wrap"
                    labelAlign="left"
                    labelWrap
                    labelCol={{ flex: '150px' }}

                >
                    <Card title="Tool Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: '20px' }}>
                        <Form.Item name={"toolName"} label={<span style={{ fontSize: '16px' }}>Tool Name</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"toolStatus"} label={<span style={{ fontSize: '16px' }}>Status</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"toolTotal"} label={<span style={{ fontSize: '16px' }}>Total</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"numOfTool"} label={<span style={{ fontSize: '16px' }}>Borrow</span>}
                        >
                            <Input disabled
                                value={form.getFieldValue("numOfTool")}
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: 'calc(100% - 40px)',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                            {/* <EditOutlined onClick={showModal} style={{ cursor: 'pointer', marginLeft: '8px' }} /> */}
                        </Form.Item>
                    </Card>

                    {/* <Card title="Retreat Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: '20px' }}>
                        <Form.Item name={"name"} label={<span style={{ fontSize: '16px' }}>Retreat Name</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"startDate"} label={<span style={{ fontSize: '16px' }}>Start Date</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"status"} label={<span style={{ fontSize: '16px' }}>Status</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                    </Card> */}

                    <Card title="Borrower Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: '20px' }}>
                        <Form.Item name={"firstName"} label={<span style={{ fontSize: '16px' }}>First Name</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"lastName"} label={<span style={{ fontSize: '16px' }}>Last Name</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"email"} label={<span style={{ fontSize: '16px' }}>Email</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"role"} label={<span style={{ fontSize: '16px' }}>Role</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                        <Form.Item name={"createAt"} label={<span style={{ fontSize: '16px' }}>Date Borrow</span>}
                        >
                            <Input disabled
                                style={{
                                    border: 'none',
                                    color: 'rgba(0, 0, 0, 0.88)',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    textAlign: 'left'
                                }}
                            />
                        </Form.Item>
                    </Card>

                </Form>


            </div>
            <Modal title="Edit Number of Tools" open={isModalVisible} onCancel={handleCancel}
                footer={() => (
                <>
                    <Button onClick={handleCancel}>Cancel</Button>
                    <Button type="primary" onClick={handleOk}>Confirm</Button>
                </>
            )}>
                <Input
                    type="number"
                    value={numOfTool}
                    onChange={(e) => setNumOfTool(e.target.value)}
                />

            </Modal>
        </div>
    )

}
export default AdminDetailToolHistory